const bridge = () =>
  typeof window !== "undefined" ? window.desktopOfflineOrders : null;

export const deleteOfflineOrder = async (restaurantId, order) => {
  const api = bridge();
  if (!api?.remove) {
    throw new Error("Restart the desktop app to initialize offline order storage.");
  }
  return api.remove({
    restaurantId,
    orderId: order?.id ?? order?.orderid ?? order?.order_id,
    orderCode: order?.ordercode ?? order?.order_code,
  });
};

export const listOfflineDeletedOrders = (restaurantId, filters = {}) => {
  const api = bridge();
  if (!api?.listDeleted) {
    throw new Error("Restart the desktop app to initialize offline order history.");
  }
  return api.listDeleted({ restaurantId, ...filters });
};

export const restoreOfflineDeletedOrder = (restaurantId, logId) => {
  const api = bridge();
  if (!api?.restoreDeleted) {
    throw new Error("Restart the desktop app to initialize offline order history.");
  }
  return api.restoreDeleted({ restaurantId, logId });
};

export const listOfflineOrderEditHistory = (restaurantId, filters = {}) => {
  const api = bridge();
  if (!api?.listEditHistory) {
    throw new Error("Restart the desktop app to initialize offline order edit history.");
  }
  return api.listEditHistory({ restaurantId, ...filters });
};

export const getOfflineOrderEditHistory = (restaurantId, historyId, orderId) => {
  const api = bridge();
  if (!api?.getEditHistory) {
    throw new Error("Restart the desktop app to initialize offline order edit history.");
  }
  return api.getEditHistory({ restaurantId, historyId, orderId });
};
